import PropTypes from "prop-types";
import styles from "./index.css";
import CommonProductTileControls from "../../common/SavedItemsProductTileControls";
import DeleteButton from "../../../containers/customerItems/DeleteButton";
import ProductSizeSelect from "../../../containers/customerItems/ProductSizeSelect";
import NotifyMeButton from "../../../containers/customerItems/NotifyMeButton";
import content from "app-content";

const ProductTileControls = ({
  isForceDisabled,
  isBackInStockNotificationEnabled,
  ...rest
}) => (
  <>
    <CommonProductTileControls
      {...rest}
      toBagButtonText={content.saved_items_item_move_to_bag}
      isForceDisabled={isForceDisabled}
      ProductSizeSelectComponent={ProductSizeSelect}
    />
    {isBackInStockNotificationEnabled && (
      <NotifyMeButton {...rest} isDisabled={isForceDisabled} />
    )}
    <DeleteButton
      {...rest}
      disabled={isForceDisabled}
      className={styles.deleteButton}
    />
  </>
);

ProductTileControls.propTypes = {
  id: PropTypes.string.isRequired,
  isForceDisabled: PropTypes.bool.isRequired,
  isBackInStockNotificationEnabled: PropTypes.bool.isRequired
};

export default ProductTileControls;
